import { get } from 'lodash';
import { AssuranceIcon } from 'images';
import { LocationResponse, ItemResultProps, MarkerType } from './types';

export const mapLocationsToMarkers = (
  locations: LocationResponse[],
): MarkerType[] => {
  return locations.map((location: LocationResponse, index: number) => ({
    icon: get(AssuranceIcon, location.type),
    id: index,
    position: {
      lat: +location.latitude,
      lng: +location.longitude,
    },
  }));
};

export const mapLocationsToItemResults = (
  locations: LocationResponse[],
): ItemResultProps[] => {
  return locations.map((location: LocationResponse, index: number) => ({
    title: location.raison_sociale,
    subTitle: location.adresse,
    id: index,
    ...location,
  }));
};
